
export const validateFileName = (_, value) => {
  const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  if (value.includes(" ") || specialChars.test(value) || !isNaN(value[0])) {
    return Promise.reject("wrong file name format");
  }
  return Promise.resolve();
};

